export function safeStr(string?: string | number, fallback = "-"): string {
  const safe = typeof string === "number" ? String(string) : string;
  return safe || fallback;
}
